import { useEffect } from "react";
import { EdicaoLayoutPersonalizadoHibrido } from "src/components/projetos/edicao/layouts/EdicaoLayoutPersonalizadoHibrido";
import { ProjetoPersonalizadoHibrido } from "src/components/projetos/personalizados_hibrido";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto personalizado híbrido";

export const ProjetoPersonalizadoHibridoEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayoutPersonalizadoHibrido>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetoPersonalizadoHibrido />
          </div>
        </div>
      </div>
    </EdicaoLayoutPersonalizadoHibrido>
  );
};
